var forceCast=function(input){return input};export default forceCast;
//# sourceMappingURL=forceCast.js.map